module.exports = __webpack_public_path__ + "img/environthon.eefb9535.png";